<template>
  <div>
    <headers />

    <!-- <div class="breadcrumb" :key="itemKey">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ "考试中心" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="content">
      <div class="contentScore">
        <div class="contentScoreTop">
          <span class="num">{{
            result.score > 10 ? result.score : "0" + result.score
          }}</span>
          <span class="numText">分</span>
        </div>

        <div class="contentScoreResult">
          <div class="resTime">{{ times }}</div>
          <div class="resTimeText">考试用时</div>
          <div class="resType" :class="[result.state == 3 && 'resTypeErr']">
            {{ result.state == 2 ? "考试通过" : "考试未通过" }}
          </div>
        </div>
      </div>

      <div class="contentTiPs">
        {{
          result.state == 2
            ? "恭喜您通过考核，感谢您的参与！"
            : "很遗憾您未通过考核，不要气馁，再接再厉！"
        }}
      </div>
      <div class="dtBtn" @click="onClickSituation">查看答题情况</div>
      <div class="contentBtn flexCenter" @click="onClicks">
        {{ result.state == 2 ? "申请签约物资" : "重新考试" }}
      </div>
    </div>

    <openCode ref="openCode" />

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";
import openCode from "@/components/openCode.vue";
export default {
  name: "news",
  components: {
    headers,
    footers,
    search,
    openCode,
  },
  data() {
    return {
      result: {},
      times: "",
    };
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },

  created() {
    this.result = this.$route.query;
    this.times = this.formatTime(this.result.useTime);
  },
  mounted() {},
  methods: {
    // 格式化时间
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${minutes.toString().padStart(2, "0") + "分"}${
        secs.toString().padStart(2, "0") + "秒"
      }`;
    },
    onClicks() {
      if (this.result.state == 2) {
        this.$refs.openCode.openShow();
      } else {
        this.$router.replace({
          name: "examinationIndex",
        });
      }
    },
    // 查看答题情况
    onClickSituation() {
      this.$router.push({
        name: "examinationSituation",
        query: {
          id: this.result.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 1400px;
  margin: 30px auto 40px;
  box-sizing: border-box;
  padding-left: 6px;
  padding-top: 120px;
  min-height: 684px;
  display: flex;
  //   flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  .contentBtn {
    cursor: pointer;
    width: 380px;
    height: 55px;
    background: #00d8c3;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
  }
  .contentTiPs {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 17px;
    color: #00161a;
    line-height: 24px;
    text-align: center;
    font-style: normal;
    margin-bottom: 70px;
  }
  .contentScore {
    background: url("../../assets/images/resultBg.png");
    width: 214px;
    box-sizing: border-box;
    height: 214px;
    background-size: 100%;
    margin-bottom: 36px;
    padding-top: 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .contentScoreTop {
      .num {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 62px;
        color: #00d8c3;
        line-height: 87px;
        text-align: center;
        font-style: normal;
        padding-left: 20px;
      }
      .numText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #00d8c3;
        line-height: 22px;
        font-style: normal;
        margin-left: 4px;
      }
    }

    .contentScoreResult {
      transform: translateY(-10px);
      .resTime {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #00161a;
        line-height: 22px;
        text-align: center;
      }
      .resTimeText {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #829199;
        line-height: 20px;
        text-align: center;
      }

      .resType {
        height: 32px;
        background: rgba(0, 216, 195, 0.1);
        border-radius: 16px;
        margin-top: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #00d8c3;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .resTypeErr {
        width: 113px;
        background-color: rgba(209, 77, 33, 0.1);
        color: #d14d21;
      }
    }
  }
}
.dtBtn {
  font-size: 16px;
  color: #00d8c3;
  line-height: 20px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
  margin-bottom: 20px;
  cursor: pointer;
}
</style>
